import { render } from "./neighborhood-scores.vue?vue&type=template&id=36604bb8"
import script from "./neighborhood-scores.vue?vue&type=script&lang=js"
export * from "./neighborhood-scores.vue?vue&type=script&lang=js"

import "./neighborhood-scores.vue?vue&type=style&index=0&id=36604bb8&lang=css"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__